import {ActionBarBehavior} from "../action-bar-behavior";
import {takeUntil} from 'rxjs/operators';
import {BsModalService} from 'ngx-bootstrap/modal';
import {OnDestroy, Injectable} from '@angular/core';
import * as _ from 'lodash';
import {Subject, Subscription} from 'rxjs';
import { ActionBarConfig } from 'src/shared/model/action-bar-config';
import { CustomActionBarTypeEnum } from 'src/shared/constants/custom-action-bar-type.enum';
import { ActionBarType } from 'src/shared/constants/action-bar-type.enum';
import { CustomActionEvent } from '../../service/custom-action-event';

@Injectable()
export class RefreshActionBarBehavior extends ActionBarBehavior implements OnDestroy {

  ngUnsubscribe: Subject<boolean> = new Subject<boolean>();
  subscriptions: Subscription[] = [];

  constructor(
    private csCustomAction: CustomActionEvent,
    private dialogService: BsModalService,
  ) {
    super();
  }
  executeAction(actionBarConfig: ActionBarConfig, selectedRecords: any[], additionalParams: any) {
    this.confirmAction(additionalParams,(callBack: any) => {
      this.csCustomAction.emitChange({
          type: CustomActionBarTypeEnum.REFRESH,
          value: additionalParams.disabledAction,
          actionId: additionalParams.actionId});
    });
  }

  private confirmAction(additionalParams: any, callBack: Function) {
    // if (additionalParams.isConfirm || !additionalParams.disabledAction) {
    //   const confirmState = this.dialogService.show(
    //     CsConfirmationDialogComponent,
    //     {
    //       initialState: CommonInits.confirmDialogForUnsavedData(
    //         ActionState.REFRESH
    //       )
    //     }
    //   );

    //   confirmState.setClass('modal-dialog-centered');
    //   this.subscriptions.push(this.dialogService.onHide
    //     .pipe(takeUntil(this.ngUnsubscribe))
    //     .subscribe(() => {
    //       if (confirmState.content.confirmed) {
    //         callBack();
    //       }
    //       this.unsubscribe();
    //     })
    //   );
    //   return;
    // }
    callBack();
  }

  isActionBar(type: ActionBarType): boolean {
    return ActionBarType.REFRESH === type;
  }

  unsubscribe() {
    _.forEach(this.subscriptions, (subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.unsubscribe();
  }
}
